// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bank-account-container-s1MJI {
  overflow-x: auto;
  padding: 0px 32px 20px;
}

.bank-account-toolbar-oNJ3l {
  min-width: 1060px;
  height: 56px;
  display: flex;
  gap: 32px;
  align-items: center;
}

.bank-account-toolbarRight-sn24K {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
}

.bank-account-title_container-Wr8hC {
  width: 360px;
  flex-grow: 0;
  flex-shrink: 0;
}

.bank-account-title_title-hiUYT {
  font-size: 17px;
}

.bank-account-title_icon-_Xot1 {
  --size: 20px;
}

.bank-account-content-iUUjD {
  min-width: 1060px;
  display: flex;
  gap: 32px;
  margin-top: 0px;
}

.bank-account-outlineCard-BDUZj {
  width: 360px;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: center;
}

.bank-account-image-x1Nyv {
  display: block;
  width: 80px;
  margin: 40px auto;
}

.bank-account-bankAccountTitle-u7xEP {
  text-align: center;
  color: rgba(0, 0, 0, 0.8);
  font-size: 18px;
  font-weight: 500;
  padding-bottom: 40px;
}

.bank-account-detailItem_container-Xl779 {
  width: auto;
  margin: 0px 24px;
  padding: 20px 0px;
}

.bank-account-detailItem_title-MxD5K {
  font-size: 15px;
  font-weight: normal;
}

.bank-account-detailItem_text-x2QY3 {
  font-weight: 500;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.75);
}

.bank-account-detailItem_green-wWRst {
  color: var(--money-color);
}

.bank-account-outlineCardRight-FeG4i {
  height: auto;
  flex-grow: 1;
  overflow: auto;
}

.bank-account-tab_container-BaQmG, .bank-account-tab_container-BaQmG:first-of-type {
  cursor: pointer;
  padding: 0px;
}

.bank-account-tab_container-BaQmG:first-of-type {
  margin-left: 4px;
}

.bank-account-tab_container-BaQmG:not(:last-of-type) {
  margin-right: 48px;
}

.bank-account-tab_container-BaQmG:hover {
  background-color: unset;
}

.bank-account-tab_title-giCZN {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.9);
}

.bank-account-tab_indicator-dyaYm {
  border-radius: 2px;
  margin: 12px 2px 0px;
}

.bank-account-tableHeader_container-SpKD2 {
  height: 48px;
}

.bank-account-tableHeader_cellContent-EMuxP {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
}
`, "",{"version":3,"sources":["webpack://./src/pages/bank-account/bank-account.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B","sourcesContent":[".container {\n  overflow-x: auto;\n  padding: 0px 32px 20px;\n}\n\n.toolbar {\n  min-width: 1060px;\n  height: 56px;\n  display: flex;\n  gap: 32px;\n  align-items: center;\n}\n\n.toolbarRight {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-grow: 1;\n}\n\n.title_container {\n  width: 360px;\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n\n.title_title {\n  font-size: 17px;\n}\n\n.title_icon {\n  --size: 20px;\n}\n\n.content {\n  min-width: 1060px;\n  display: flex;\n  gap: 32px;\n  margin-top: 0px;\n}\n\n.outlineCard {\n  width: 360px;\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-items: center;\n}\n\n.image {\n  display: block;\n  width: 80px;\n  margin: 40px auto;\n}\n\n.bankAccountTitle {\n  text-align: center;\n  color: rgba(0, 0, 0, 0.8);\n  font-size: 18px;\n  font-weight: 500;\n  padding-bottom: 40px;\n}\n\n.detailItem_container {\n  width: auto;\n  margin: 0px 24px;\n  padding: 20px 0px;\n}\n\n.detailItem_title {\n  font-size: 15px;\n  font-weight: normal;\n}\n\n.detailItem_text {\n  font-weight: 500;\n  font-size: 15px;\n  color: rgba(0, 0, 0, 0.75);\n}\n\n.detailItem_green {\n  color: var(--money-color);\n}\n\n.outlineCardRight {\n  height: auto;\n  flex-grow: 1;\n  overflow: auto;\n}\n\n.tab_container, .tab_container:first-of-type {\n  cursor: pointer;\n  padding: 0px;\n}\n\n.tab_container:first-of-type {\n  margin-left: 4px;\n}\n\n.tab_container:not(:last-of-type) {\n  margin-right: 48px;\n}\n\n.tab_container:hover {\n  background-color: unset;\n}\n\n.tab_title {\n  font-size: 15px;\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.tab_indicator {\n  border-radius: 2px;\n  margin: 12px 2px 0px;\n}\n\n.tableHeader_container {\n  height: 48px;\n}\n\n.tableHeader_cellContent {\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.8);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `bank-account-container-s1MJI`,
	"toolbar": `bank-account-toolbar-oNJ3l`,
	"toolbarRight": `bank-account-toolbarRight-sn24K`,
	"title_container": `bank-account-title_container-Wr8hC`,
	"title_title": `bank-account-title_title-hiUYT`,
	"title_icon": `bank-account-title_icon-_Xot1`,
	"content": `bank-account-content-iUUjD`,
	"outlineCard": `bank-account-outlineCard-BDUZj`,
	"image": `bank-account-image-x1Nyv`,
	"bankAccountTitle": `bank-account-bankAccountTitle-u7xEP`,
	"detailItem_container": `bank-account-detailItem_container-Xl779`,
	"detailItem_title": `bank-account-detailItem_title-MxD5K`,
	"detailItem_text": `bank-account-detailItem_text-x2QY3`,
	"detailItem_green": `bank-account-detailItem_green-wWRst`,
	"outlineCardRight": `bank-account-outlineCardRight-FeG4i`,
	"tab_container": `bank-account-tab_container-BaQmG`,
	"tab_title": `bank-account-tab_title-giCZN`,
	"tab_indicator": `bank-account-tab_indicator-dyaYm`,
	"tableHeader_container": `bank-account-tableHeader_container-SpKD2`,
	"tableHeader_cellContent": `bank-account-tableHeader_cellContent-EMuxP`
};
export default ___CSS_LOADER_EXPORT___;
